export default "__VITE_ASSET__476ffacd__"